import { WithAdditionalMarketoFormOverrideProps } from 'marketing-site/src/components/context/MarketoFormOverridePropsContext'
import {
  IOnMarketoFormSubmit,
  IProps as IMarketoFormV2Props,
  SIGNUP_INTENT,
} from 'marketing-site/src/library/components/MarketoFormV2'
import { useSessionStorage } from 'marketing-site/src/library/hooks/use-session-storage'
import { AnalyticsEvent } from 'marketing-site/src/library/utils/analytics/analyticsEvent'
import { shouldTalkToSales } from 'marketing-site/src/library/utils/getSignupIntentRedirectPath'
import React, { useEffect } from 'react'
import { IPageBehaviorComponentProps } from './PageBehaviors'
import Cookies from 'js-cookie'

export default function InboundForm({ children }: IPageBehaviorComponentProps): React.ReactElement {
  const [isUma, setIsUma] = useSessionStorage<boolean | null>('is-uma', null)

  useEffect(() => {
    if (typeof isUma === 'boolean') {
      if (!window.location.href.includes('/view-demos-submitted')) {
        window.location.replace('/view-demos-submitted')
      }
    }
  }, [])

  const onMarketoFormSubmit: IOnMarketoFormSubmit = (response, _, emailSubmissionResult) => {
    if (response.success) {
      const isTalkToSales = shouldTalkToSales(emailSubmissionResult)

      const event = new AnalyticsEvent({
        action: 'clicked',
        object: 'cta',
        context: 'inbound_demos_page',
        place: 'view-demos_page',
      })

      event.send()

      setIsUma(isTalkToSales)
      if (isTalkToSales) {
        Cookies.set('t2s', '1', { expires: 90 })
      }
      window.location.replace('/view-demos-submitted')
    }
  }

  const marketoOverrideProps: Partial<IMarketoFormV2Props> = {
    onSubmit: onMarketoFormSubmit,
    hiddenFieldIds: ['FirstName'],
    emailSubmissionSource: SIGNUP_INTENT,
  }

  return (
    <WithAdditionalMarketoFormOverrideProps overrideProps={marketoOverrideProps}>
      {children}
    </WithAdditionalMarketoFormOverrideProps>
  )
}
